import React from "react";
import { subscribe } from "../libs/loading";

type State = { active: string[] };

export default class LoadingOverlay extends React.Component<{}, State> {
  state: State = { active: [] };
  private _unsub: (() => void) | null = null;

  componentDidMount() {
    this._unsub = subscribe((active) => this.setState({ active }));
  }

  componentWillUnmount() {
    this._unsub?.();
  }

  render() {
    if (this.state.active.length === 0) return null;
    const top = this.state.active[this.state.active.length - 1];
    const label = top.slice(top.indexOf(":") + 1);
    return (
      <div className="vm-loading-overlay" role="status" aria-live="polite">
        <div className="vm-loading-overlay__card">
          <span className="vm-loading-overlay__spinner" aria-hidden="true" />
          <span className="vm-loading-overlay__text">{label}</span>
        </div>
      </div>
    );
  }
}
